module.exports = __webpack_public_path__ + "media/packs/images/flags/GN-c1566412e0681cf5f674e94b889565d5.png";